import { render, staticRenderFns } from "./OrderPayments.vue?vue&type=template&id=1ae63930&scoped=true"
import script from "./OrderPayments.vue?vue&type=script&lang=js"
export * from "./OrderPayments.vue?vue&type=script&lang=js"
import style0 from "./OrderPayments.vue?vue&type=style&index=0&id=1ae63930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae63930",
  null
  
)

export default component.exports